{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Anwendungen",
    "back": "Zurück",
    "campaigns": "Kampagnen",
    "dashboard": "Dashboard",
    "devices": "S4 – lokale Station",
    "dtwins": {
      "label": "Geräte",
      "manage": {
        "fleets": "Flotten",
        "label": "Verwalten",
        "devices": "Geräte"
      },
      "overview": {
        "label": "Übersicht",
        "map": "Karte"
      }
    },
    "logout": "Abmelden",
    "logs": "Protokolle",
    "overview": "Übersicht",
    "parameters": {
      "label": "Parameter",
      "platformMgt": "Plattformverwaltung",
      "features": {
        "applicationManagement": "Anwendungen",
        "firmwareManagement": "Firmware",
        "deviceConfiguration": "Geräteparametrierung",
        "label": "Funktionen",
        "licenseManagement": "Lizenz",
        "interfaces": "Schnittstellen"
      },
      "monitoring": {
        "label": "Überwachung",
        "settings": "Berichterstattung"
      }
    },
    "product": "Produkt",
    "sector": {
      "label": "Sektor",
      "placeholder": "Sektor auswählen"
    },
    "sectors": "Sektoren",
    "settings": "Verwaltung",
    "users": "Benutzer"
  },
  "header": {
    "sectors": "Sektoren",
    "userMenu": {
      "title": "Kontomenü",
      "logout": "Abmelden",
      "userAccount": "Benutzerkonto",
      "about": "Info",
      "connectMyMobileApp": "Meine mobile App verbinden"
    },
    "admin": "Verwaltung",
    "delegation": {
      "select": {
        "label": "Organisation auswählen",
        "title": "Organisation auswählen"
      }
    }
  }
}
